import global$1 from './global.js';

var global = global$1;
var TypeError = global.TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
  return passed;
};

export { validateArgumentsLength as default };
